<template>
  <v-product-link
    :product="product"
    class="o-button"
  >
    <i
      class="o-icon o-button__icon"
      :class="iconClass"
    ></i>
    <span
      v-if="showLabel"
      class="o-typography__label o-button__label"
    >
      {{ label }}
    </span>
  </v-product-link>
</template>
<script>
  import VProductLink from '../product-link/index.vue';

  export default {
    components: {
      VProductLink,
    },
    props: {
      product: Object,
      iconClass: {
        type: String,
        default: 'o-icon--info',
      },
      showLabel: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default() {
          return this.product.buttonLabel || this.$t('product.info');
        },
      },
    },
  };
</script>
